import BaseRequest from './BaseRequest';

const schema = 'affiliate-admin';

export default class AffiliateRequest extends BaseRequest {
  /**
     * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
     */
  fetchSetting() {
    const url = `${schema}`;
    return this.get(url);
  }

  /**
     *
     * @param {Object} param
     * @param {Object} param.affiliate_setting
     * @param {int} param.affiliate_setting.level
     * @param {float} param.affiliate_setting.rate
     * @param {string} param.pubkey
     */
  postSetting(data) {
    const url = `${schema}`;
    return this.post(url, data);
  }
}
